import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";

// Others File


const Aboutus = () => {
  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="aboutus" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">درباره ما</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
          <p className="text-sm leading-8 text-mygray-500">
            سامانه رفاپ بر گرفته از رفاه فرهنگیان آموزش و پرورش است که توسط شرکت
            ارزیابی خسارت مستقل بیمه ای ارزیابان ایرانیان پوشش با همکاری اداره
            کل رفاه وزارت آموزش جهت ارتقا رضایت و جلوگیری از تضییع حق وحقوق بیمه
            ای فرهنگیان و دانش آموزان راه اندازی گردیده است.
          </p>
          <p className="font-bold text-lg text-mygray-700 mt-4">
            نقش شرکت مستقل ارزیابی چیست ؟
          </p>
          <p className="text-sm leading-8 text-mygray-500">
            با توجه به اینکه این سؤال در ذهن بیمه گذاران نقش می بندد که چرا
            ابتکار عمل برای تعیین میزان و نحوه جبران خسارت دراختیار بیمه گران
            است؟!! و چگونه شرکت بیمه که یکی از اطراف عقد بیمه محسوب می شود بطور
            یکجانبه اجازه ارزیابی اولیه، صدور بیمه نامه، و یا میزان برآورده
            خسارت و تشخیص تعهد بیمه نامه و مطابقت حادثه با شرایط بیمه نامه و در
            نهایت پذیرش یا رد خسارت را بر عهده دارد. فرض کنیم اگر داور یک مسابقه
            فوتبال، سهامدار یکی از دو تیم باشد، این امر موجب تضاد منافع بوده و
            داور دیگر نمی تواند بی طرف قلمداد شود. در مورد ارزیابی خسارت نیز، از
            آنجایی که وظیفه اصلی ارزیاب، قضاوت و حکمیت است، ارتباط مالی با بیمه
            گران موجب تضاد منافع خواهد بود. و با توجه به محدودیت های قانونی
            کارکنان وسهام داران شرکت های ارزیابی تحت هیچ شرایطی نمی توانند
            کارمند شرکت های بیمه ای یا نمایندگی آنها باشند و نظر به اینکه صنعت
            بیمه فعالیتی است متکی به علم و پایه‌های آن بر محاسبات پیچیده و
            کاربرد روش‌های آمار و احتمالات استوار است، عرصه این فعالیت ، بسیار
            گسترده و رشته ‌های مختلف آن پیچیدگی خاصی دارد و نحوه محاسبات و عدم
            آشنایی با قوانین، بخشنامه‌ها، آئین‌نامه ها... کار بیمه شده گان را
            دشوار کرده است. در این راستا بیمه گذاران آگاه جهت مدیریت تعارض در
            منافع از روش TPA در واقع واگذاری نظارت به یکی شرکت مستقل ممیزی
            وتخصصی استفاده می کنند و با توجه به پیچیدگی قوانین و مقررات بیمه ای
            جهت جلوگیری از تضییع حق وحقوق بیمه شده این روش در کشورهای توسعه
            یافته و به تازگی در ایران به مدیریت شفاف سازی و نقش آن در بهبود
            اجرای قرارداد بیمه ای کمک بزرگی نموده است و بعنوان مرجع مرضی الطرفین
            و مستقل در ارتقا رضایت بیمه شده بسیار موثر بوده است. وزارت آموزش و
            پروش بعنوان بعنوان بزرگترین بیمه گذار کشور از ابتدا تیر سال 1401
            قرارداد های بیمه ای قریب 17 میلیون دانش آموز و فرهنگی را در رشته
            بیمه های درمان ، حوادث و بیمه های اموال و سایر رشته ها را به شرکت
            بیمه دانا واگذار نمود ه است و شرکت ایرانیان پوشش نخستین شرکت ارزیابی
            خسارت وتنها شرکت جامع ارزیابی کشور تحت نظارت بیمه مرکزی جمهوری
            اسلامی ایران را بعنوان ناظر خود در این قرارداد معرفی نموده است .
          </p>
          <p className="font-bold text-lg text-mygray-700 mt-4">TPA چیست؟</p>
          <p className="text-sm leading-8 text-mygray-500">
            شرکت ایرانیان پوشش برای بهبود کیفیت در حین استفاده ، وهمچنین کاهش
            تعداد خطا و سوءاستفادهای احتمالی، بطور دقیق نقاط ضعف فنی و فیزیکی در
            پروژها برای بیمه گزارن واحد بازرسی و نظارت THIRD PARTY AUTHORITY راه
            اندازی نموده است .در صورتیکه خسارت توسط کارشناسان شرکت بیمه یا
            ارزیاب خسارت بررسی گرددایرانیان پوشش بعنوان TPA (شخص سوم ) بر
            قرارداد نظارت می کند. بیمه گذاران حقوقی برای راست آزمایی برآورد
            خسارت و تعیین تشخیص تعهد بیمه گر در قرارداد بیمه ای از خدمات این
            شرکت بزرگ ارزیابی استقبال کرده اند
          </p>
          <p className="font-bold text-lg text-mygray-700 mt-4">
            درباره ایرانیان پوشش
          </p>
          <p className="text-sm leading-8 text-mygray-500">
            هلدینگ ایرانیان پوشش با شناسائی نقاط ضعف و قوت و موانع و چالش‌های
            پیش روی توسعه صنعت بیمه , با عنایت و توکل به خداوند , توانست در سال
            ۱۳۹۱ مصادف با سال تولید ملی , حمایت از کار و سرمایه ایرانی و در لبیک
            به فرمایش مقام معظم رهبری ایده ایستگاه نوآوری تخصصی بیمه ای منهای
            فروش را ؛ راه اندازی و در روز بیمه (دقیقاً در سیزده آذر سال 1391) به
            میمنت و مبارکی این روز ثبت برند و شرکت تاسیس نمايد.
            <br />
            اهداف عالی موسسین هلدینگ ایرانیان پوشش , تاسیس و راه اندازی 12 شرکت
            تخصصی و حرفه ای در صنعت بیمه (منهای فروش) با موضوعات : ارزیابی خسارت
            بیمه ای ، ریسک ، ایمنی ، آکچوئری ، داده کاوی ، آموزش ، پژوهش ،
            ریکاوری ، داوری ، رسانه ، تحقیق ، بازرسی ، حسابرسی ، حقوقي و وکالت
            بيمه گران ، مشاوره ، امداد و کمک‌رسان ، تکنولوژی و فن‌آوری‌اطلاعات
            است . باور قلبی و ذهنی ما در هلدینگ ایرانیان پوشش از آغاز کار شعار
            "مراقب بیمه (حافظ رابطه بیمه گر و بیمه گذار)" است
          </p>
          <a href="https://iranianpooshesh.com/aboutus" target="_blank">
            <p className="mt-8 text-sky-500 hover:text-sky-600">
              برای مشاهده سایت ایرانیان پوشش کلیک کنید.
            </p>
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Aboutus;
